import Vue from 'vue'
import App from './App.vue'
import firebase from "firebase/app";
import "firebase/analytics";

import './registerServiceWorker'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import Notifications from 'vue-notification'
import '@/assets/theme.scss';
import 'nprogress/nprogress.css';
import vueAwesomeCountdown from 'vue-awesome-countdown'


Vue.config.productionTip = false
Vue.use(Buefy);
Vue.use(Notifications);
Vue.use(vueAwesomeCountdown, 'vac')

const firebaseConfig = {
  apiKey: "AIzaSyCNz1wlB_b7KQjqnPrXPfSO_9zUjzfs9Uo",
  authDomain: "wintambola-game.firebaseapp.com",
  databaseURL: "https://wintambola-game-default-rtdb.firebaseio.com",
  projectId: "wintambola-game",
  storageBucket: "wintambola-game.appspot.com",
  messagingSenderId: "193985091596",
  appId: "1:193985091596:web:a7cd19c5f31a7fa4463629",
  measurementId: "G-3MW74ZV7TX"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
